<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><a id="page4"></a>Red Sky at Night</p>
<p class="noindent">If the sun rests in the notch</p>
<p class="noindents">on that mountain ridge.</p>
<p class="center"><img alt="image" src="images/logo.jpg"/></p>
<p class="noindent">If an old woman is scribbling.</p>
<p class="center"><img alt="image" src="images/logo.jpg"/></p>
<p class="noindent">If an old man alone</p>
<p class="noindents">in the breakfast room</p>
<p class="noindent">at the Vagabond Executive</p>
<p class="noindents">Motor Inn</p>
<p class="noindent">doing crossword puzzles</p>
<p class="noindents">beneath <span class="font-i">The Early Show</span></p>
<p class="noindents">babble</p>
<p class="noindent">continues.</p>
<p class="center"><img alt="image" src="images/logo.jpg"/></p>
<p class="noindent">If the tree blooms pink</p>
<p class="noindents">there will be more</p>
<p class="noindent">than we can imagine</p>
<p class="noindents">always,</p>
<p class="noindent">extra promptings</p>
<p class="noindents">of pure nothing</p>
<p class="noindent">which we can neither</p>
<p class="noindents">keep nor forget.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Chapter002.vue?f49147dc